import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export const BtnPendingInvites = shouldShow => {
  const { t } = useTranslation()

  return shouldShow ? (
    <div>
      <p>{t('collaborators_area.you_have_pending_invites')}</p>
      <Link to="/tools/collaborators-area/invites" className="hot-button hot-button--secondary hot-button--block _my-2">
        {t('collaborators_area.see_invite')}
      </Link>
    </div>
  ) : null
}
